import Debtor from '@/views/debtor/Details.vue'

const router = {
    path: '/debtors/:debtorId',
    name: 'DebtorDetails',
    component: Debtor,
    meta: {
        title: 'Debtor Details'
    }
  };

export default router
